module.exports = __webpack_public_path__ + "img/silver-medal.6747eef6.png";